import React from "react";
import "./BlockUser.css";

export const BlockUser = () => {
    return (
        <div className="block-screen-box">
            <div className="block-content">
                <div className="block-title">Update Required</div>
                <div className="block-message">
                    Please download the new Park+ LeadX App to continue.
                </div>
                <div className="block-message">
                    The new version includes enhanced performance, bug fixes, and new features.
                </div>
                <a
                    href="https://play.google.com/store/apps/details?id=io.parkplus.ppleadx"
                    className="block-button"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Download Now
                </a>
            </div>
        </div>
    );
};

export default BlockUser;